export const DRAWER_OPEN = "@SavavePortalVendas:DRAWER_OPEN"
export const THEME = "@SavavePortalVendas:THEME"
